// @ts-nocheck
import {lazy, FC, Suspense, useEffect, useState} from 'react'
import {Route, Routes, Navigate, useParams, useMatch} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {GrantAccessWrapper} from '../pages/grantaccess/GrantAccessWrapper'
import {ContactsWrapper} from '../pages/contacts/ContactsWrapper'
import {GroupsWrapper} from '../pages/groups/GroupsWrapper'
import {PlansWrapper} from '../pages/plans/PlansWrapper'
import {StatsWrapper} from '../pages/stats/StatsWrapper'
import {PaymentInformationWrapper} from '../pages/payment/PaymentInformationWrapper'
import {AffiliateWrapper} from '../pages/affiliate/AffiliateWrapper'
import {AffiliatePaymentRequestWrapper} from '../pages/affiliate/AffiliatePaymentRequestWrapper'
import {AffiliateTutorialWrapper} from '../pages/affiliate/AffiliateTutorialWrapper'
import {AffiliateLeadsWrapper} from '../pages/affiliate/AffiliateLeadsWrapper'
import {AffiliateAdvertisingWrapper} from '../pages/affiliate/AffiliateAdvertisingWrapper'
import {AffiliateAddNewClientWrapper} from '../pages/affiliate/AffiliateAddNewClientWrapper'
import AffiliateDashboardWrapper from '../pages/affiliate/AffiliateDashboardWrapper'
import AffiliateAddCustomerWrapper from '../pages/affiliate/AffiliateAddCustomerWrapper'
import AffiliateWhatsappWrapper from '../pages/affiliate/AffiliateWhatsappWrapper'
import AffiliateClientRegisterWrapper from '../pages/affiliate/AffiliateClientRegisterWrapper'
import AffiliatePayoutsWrapper from '../pages/affiliate/AffiliatePayoutsWrapper'
import AffiliateLeadsMgrWrapper from '../pages/affiliate/AffiliateLeadsMgrWrapper'
import AffiliateMeetingsWrapper from '../pages/affiliate/AffiliateMeetingsWrapper'
import AffiliateAgentImportWrapper from '../pages/affiliate/AffiliateAgentImportWrapper'
import BulkProfilesWrapper from '../pages/profiles/BulkProfilesWrapper'
import {VirtualNumberWrapper} from '../pages/virtual-number/VirtualNumberWrapper'
import ApiAccessPage from '../pages/api-access/ApiAccessPage'










import {SchedulingDisributionWrapper} from '../pages/groups/SchedulingDisributionWrapper'
import {SettingsWrapper} from '../pages/settings/SettingsWrapper'
import {AddOnsWrapper} from '../pages/addons/AddOnsWrapper'
import ProfilePage from '../modules/profiles/ProfilePage'
import {ChatWrapper} from '../pages/chat/ChatWrapper'
import {ContentWrapper} from '../pages/content/ContentWrapper'
import { PaymentWrapper } from '../pages/payment/PaymentWrapper'
import {SupportWrapper} from '../pages/support/SupportWrapper'
import {MarketplaceWrapper} from '../pages/marketplace/MarketplaceWrapper'
import {FacebookCommentsWrapper} from '../pages/facebook-comments/FacebookCommentsWrapper'
import {ScheduleWrapper} from '../pages/schedule/ScheduleWrapper'
import {Th3PostSyncWrapper} from '../pages/th3post-sync/Th3PostSyncWrapper'
import {GroupSchedulingWrapper} from '../pages/group-scheduling/GroupSchedulingWrapper'
import {TermsWrapper} from '../pages/terms/TermsWrapper'
import {PrivacyWrapper} from '../pages/privacy/PrivacyWrapper'
import {Logout, AuthPage, useAuth} from '../modules/auth'

const PaymentsWrapper = lazy(() => import('../pages/payments/PaymentsWrapper').then(m => ({ default: m.PaymentsWrapper })))

const PrivateRoutes = () => {
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const {currentUser, getBot} = useAuth()

  const params = new URLSearchParams(window.location.search);
  var token = params.get('overide-token');
  if (token) {
    setTimeout(() => {  
      localStorage.setItem('kt-auth-react-v', JSON.stringify({api_token: token}));

      const url = window.location.protocol + "//" + window.location.host + window.location.pathname;

      // Redirect to the constructed URL
      window.location.href = url;
    }, 1000)
  }


  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Groups after success login/registartion */}

        <Route path='auth/*' element={<Navigate to='/campaigns' />} />
        {/* Pages */}
        <Route path='new-bot' element={<SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path='grant-access' element={getBot() ? <GrantAccessWrapper /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path='contacts' element={<ContactsWrapper />} />
        <Route path='payment' element={getBot() ? <PaymentWrapper /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path="plans" element={<PlansWrapper />} />
        <Route path="update-payment-information" element={<PaymentInformationWrapper />} />
        <Route path="invoices" element={<PaymentInformationWrapper showinvoices={true}/>} />
        <Route path="affiliate/dashboard" element={<AffiliateDashboardWrapper />} />
        {/* Customers page merged into סוכנים ולידים (leads-manager) */}
        <Route path="affiliate/customers" element={<Navigate to="/affiliate/leads-manager" replace />} />
        <Route path="affiliate/add-customer" element={<AffiliateAddCustomerWrapper />} />
        <Route path="affiliate/whatsapp" element={<AffiliateWhatsappWrapper />} />
        <Route path="affiliate/client-register" element={<AffiliateClientRegisterWrapper />} />
        {/* Browse yad2-import retired — redirect any old links to the AI agent-import flow */}
        <Route path="affiliate/yad2-import" element={<Navigate to="/affiliate/agent-import" replace />} />
        <Route path="affiliate/payouts" element={<AffiliatePayoutsWrapper />} />
        <Route path="affiliate/leads-manager" element={<AffiliateLeadsMgrWrapper />} />
        <Route path="affiliate/meetings" element={<AffiliateMeetingsWrapper />} />
        <Route path="affiliate/agent-import" element={<AffiliateAgentImportWrapper />} />
        {/* Legacy affiliate dashboard kept for reference */}
        <Route path="affiliate/legacy-dashboard" element={<AffiliateWrapper />} />

        <Route path="affiliate/payment-request" element={<AffiliatePaymentRequestWrapper />} />

        <Route path="affiliate/tutorials" element={<AffiliateTutorialWrapper />} />
        <Route path="affiliate/leads" element={<AffiliateLeadsWrapper />} />
        <Route path="affiliate/leads/:id" element={<AffiliateLeadsWrapper />} />
        <Route path="affiliate/advertising" element={<AffiliateAdvertisingWrapper />} />
        <Route path="affiliate/add-new-client" element={<AffiliateAddNewClientWrapper />} />

        <Route path="profiles" element={<ProfilePage />} />
        <Route path="connect-profiles" element={<BulkProfilesWrapper />} />
        <Route path="stats" element={<StatsWrapper />} />
        <Route path="virtual-number" element={<VirtualNumberWrapper />} />
        <Route path="api-access" element={<ApiAccessPage />} />
        <Route path="campaigns" element={<GroupsWrapper />} />
        <Route path="campaigns/:id" element={<GroupsWrapper />} />
        <Route path="scheduling-distribution" element={<SchedulingDisributionWrapper />} />
        <Route path='settings' element={getBot() ? <SettingsWrapper /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path='add-ons' element={getBot() ? <AddOnsWrapper /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path='inbox' element={getBot() ? <ChatWrapper /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path='content' element={getBot() ? <ContentWrapper /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path='support' element={<SupportWrapper />} />
        <Route path='terms' element={<TermsWrapper />} />
        <Route path='privacy' element={<PrivacyWrapper />} />
        <Route path='marketplace' element={<MarketplaceWrapper />} />
        <Route path='marketplace/:profileId' element={<MarketplaceWrapper />} />
        <Route path='facebook-comments' element={<FacebookCommentsWrapper />} />
        <Route path='schedule' element={<ScheduleWrapper />} />
        <Route path='schedule/:slotId' element={<ScheduleWrapper />} />
        <Route path='th3post-sync' element={<Th3PostSyncWrapper />} />
        <Route path='group-scheduling' element={<GroupSchedulingWrapper />} />
        <Route path='builder' element={getBot() ? <BuilderPageWrapper /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        <Route path='menu-test' element={getBot() ? <MenuTestPage /> : <SuspensedView><PaymentsWrapper /></SuspensedView>} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
